import { featuredComics } from '@/mocks/comics';

export default function Featured() {
  return (
    <section id="featured" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
            <i className="ri-fire-fill" />
            每日热榜
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">热门漫画推荐</h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
            人气与口碑兼具的国漫精选，手机版与 APP 端同步更新，通勤路上追更不落空。
          </p>
        </div>
        <a
          href="#categories"
          className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md px-3 py-2 text-sm font-bold text-primary-700 hover:bg-primary-100/70"
        >
          更多漫画
          <i className="ri-arrow-right-line" />
        </a>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 lg:grid-cols-6">
        {featuredComics.map((comic) => (
          <article key={comic.id} className="group flex flex-col overflow-hidden rounded-lg bg-background-100 transition-transform duration-300 hover:-translate-y-1">
            <a href="#featured" className="relative block aspect-[3/4] w-full overflow-hidden">
              <img
                src={comic.cover}
                alt={`${comic.title} 漫画封面 - 咪咕漫画网`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-2 top-2 rounded-full bg-primary-500/90 px-2 py-0.5 text-[10px] font-bold text-background-50">
                {comic.heat}
              </span>
              <span className="absolute bottom-2 right-2 rounded-full bg-foreground-950/70 px-2 py-0.5 text-[10px] font-medium text-background-50 backdrop-blur-sm">
                {comic.status}
              </span>
            </a>
            <div className="flex flex-1 flex-col p-3">
              <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">{comic.title}</h3>
              <p className="mt-0.5 truncate text-xs text-foreground-500">{comic.author}</p>
              <div className="mt-2 flex items-center justify-between">
                <span className="flex items-center gap-1 text-xs font-bold text-accent-600">
                  <i className="ri-star-fill" />
                  {comic.rating}
                </span>
                <span className="truncate text-xs text-foreground-500">{comic.chapters}</span>
              </div>
              <div className="mt-2 flex flex-wrap gap-1">
                {comic.tags.map((tag) => (
                  <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-800">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}